export default {
    header: {
        searchPlaceholder: 'جستجو…',
        getPro: 'نسخه حرفه‌ای',
    },
    dashboard: 'داشبورد',
    modules: {
        sales: 'فروش',
        noc: 'مرکز عملیات شبکه',
        finance: 'مالی',
        admin: 'مدیریت',
        hotspot: 'هات‌اسپات',
    },
    branches: 'شعبه‌ها',
    hotspotCustomers: 'مشتریان هات‌اسپات',
    htsCustomers: 'مشتریان هات‌اسپات',
    hotspotParents: 'مشتریان هات‌اسپات',
    hotspotCreatePackage: 'ایجاد پکیج',
    hotspotAllowances: 'سهمیه کاربران',
    customers: 'مشتریان',
    tasks: 'وظایف',
    installationForm: 'فرم نصب',
    sales: {
        main: 'فروش',
        findCustomer: 'جستجوی مشتری',
        installationsList: 'لیست نصب ها',
        addCustomer: 'افزودن مشتری',
        offlineCustomers: 'مشتریان آفلاین',
        resellers: 'ریسلرها'
    },
    equipment: 'تجهیزات',
    billing: 'صورتحساب',
    serviceDiscounts: 'تخفیف‌های سرویس',
    taskAssignment: 'تخصیص وظایف',
    installations: 'نصب و راه‌اندازی',
    users: 'کاربران',
    settings: 'تنظیمات',
    quickbooksAdmin: 'کویک بوکس',
    qboSyncReview: 'بازبینی همگام‌سازی QBO',
    qboSyncReviewV2: 'بازبینی همگام‌سازی QBO نسخه ۲',
    qboAccounts: 'حساب‌های کویک‌بوکس (QBO)',
    quickbooksAccounts: 'حساب‌های کویک‌بوکس (QBO)',
    cashSettings: 'تنظیمات صندوق و حساب‌ها',
    cashBooks: 'دفاتر صندوق',
    cashBoxes: 'دفاتر صندوق',
    quickbooks: {
        main: 'کویک بوکس',
        admin: 'مدیریت کویک بوکس',
        syncReview: 'بررسی همگام‌سازی QBO'
    },
    language: 'انتخاب زبان',
    logout: 'خروج',
    payments: {
        main: 'پرداخت‌ها',
        cashLedger: 'دفتر صندوق',
        cashBooks: 'دفاتر صندوق شعب',
        cashBoxes: 'دفاتر صندوق شعب',
        payment: 'پرداخت',
        list: 'لیست پرداخت‌ها',
        queue: 'صف پرداخت‌ها',
        hotspot: 'پرداخت‌های هات‌سپ'
    },
    invoices: {
        main: 'فاکتورها',
        search: 'جستجوی فاکتور',
        list: 'لیست فاکتورها'
    }
} 